/// <amd-module name="Test/TestPlansHubRefresh/Pivots/ColumnOptions/DefineColumnOptionUtils" />
import { TestCase } from "TestPlanCommon/Contracts/TestPlan";

import {
    IColumnOptionKeyValuePair,
    OtherColumnOptions,
    WorkItemColumnOptions,
    CustomFieldColumn,
    isCustomField,
    getCustomFieldName
} from "./ColumnOptionsCommonUtils";

export function getAllPossibleFields(): IColumnOptionKeyValuePair[] {
    const allColumnOptionFields: IColumnOptionKeyValuePair[] = [];
    for (const key in WorkItemColumnOptions) {
        if (WorkItemColumnOptions[key] && WorkItemColumnOptions[key].authorPivot) {
            allColumnOptionFields.push({
                key: key,
                name: WorkItemColumnOptions[key].name
            });
        }
    }
    for (const key in OtherColumnOptions) {
        if (OtherColumnOptions[key] && OtherColumnOptions[key].authorPivot) {
            allColumnOptionFields.push({
                key: key,
                name: OtherColumnOptions[key].name
            });
        }
    }
    return allColumnOptionFields;
}

export function getWITColumnFields(columnOptionFields: string[]): string[] {
    const tableColumns: string[] = [];
    for (const columnOptionField of columnOptionFields) {
        if (WorkItemColumnOptions[columnOptionField] && WorkItemColumnOptions[columnOptionField].authorPivot) {
            tableColumns.push(columnOptionField);
        }
        if (isCustomField(columnOptionField)) {
            tableColumns.push(columnOptionField);
        }
    }
    return tableColumns;
}

export function getAllColumnFields(columnOptionFields: string[], customColumnFieldMap?: { [columnId: string]: string }): any {
    const tableColumns = [];
    for (const columnOptionField of columnOptionFields) {
        if (WorkItemColumnOptions[columnOptionField] && WorkItemColumnOptions[columnOptionField].authorPivot) {
            tableColumns.push({
                id: columnOptionField,
                name: WorkItemColumnOptions[columnOptionField].name
            });
        }
        if (OtherColumnOptions[columnOptionField] && OtherColumnOptions[columnOptionField].authorPivot) {
            tableColumns.push({
                id: columnOptionField,
                name: OtherColumnOptions[columnOptionField].name
            });
        }
        if (isCustomField(columnOptionField)) {
            tableColumns.push(getCustomFieldName(columnOptionField, customColumnFieldMap));
        }
    }
    return tableColumns;
}

export function getAllColumnValues(columnOptionFields: string[], testCase: TestCase): any {
    let columnOptions: any = {};
    const otherColumnOptions = OtherColumnOptions;
    const witColumnOptions = WorkItemColumnOptions;

    if (testCase && testCase.workItem && testCase.workItem.workItemFields) {
        // adds all workitem fields
        for (const columnOption of testCase.workItem.workItemFields) {
            columnOptions = { ...columnOptions, ...columnOption };
        }

        // parses all the workitem fields
        for (const columnOption in columnOptions) {
            if (witColumnOptions[columnOption] && witColumnOptions[columnOption].authorPivot) {
                columnOptions[columnOption] = witColumnOptions[columnOption].getDisplayValue(columnOptions[columnOption]);
            }

            // handle display value for custom fields
            if (isCustomField(columnOption)) {
                columnOptions[columnOption] = CustomFieldColumn.getDisplayValue(columnOptions[columnOption]);
            }
        }

        // adds non workitem fields
        for (const columnOptionField of columnOptionFields) {
            if (otherColumnOptions[columnOptionField] && otherColumnOptions[columnOptionField].authorPivot) {
                const columnValue = otherColumnOptions[columnOptionField].getDisplayValue(testCase);
                columnOptions[columnOptionField] = columnValue;
            }
            // When System.AssignedTo is empty, the field does not get parsed with other workitem fields, hence adding a special case here
            if (columnOptionField == "System.AssignedTo" && !columnOptions[columnOptionField]) {
                columnOptions[columnOptionField] =  witColumnOptions[columnOptionField].getDisplayValue(columnOptions[columnOptionField]);             
            }
        }
    }
    return columnOptions;
}
